import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    parents: [],
    isLoading: false,
    loadedParents: false,
    selectedParent: {},
}

const parentsSlice = createSlice({
    name: "parents",
    initialState,
    reducers: {
        loadParents(state, action) {
            state.parents = action.payload.parents;
            state.loadedParents = true;
        },
        appendParents(state, action) {
            // Append new parents to existing ones (for load more functionality)
            const newParents = action.payload.parents || [];
            state.parents = [...state.parents, ...newParents];
        },
        setSelectedParent(state, action) {
            state.selectedParent = action.payload;
        },
        setParentCustomFields(state, action) {
            const { parentId, customFields } = action.payload;
            if (state.selectedParent.ParentId === parentId) {
                state.selectedParent.CustomFields = customFields;
            }
        },
        setParentStudents(state, action) {
            const { parentId, students } = action.payload;
            if (state.selectedParent.ParentId === parentId) {
                state.selectedParent.Students = students;
            }
        },
        setIsLoading(state, action) {
            state.isLoading = action.payload
        },
        resetState:() => initialState,
    },
});

export const parentsActions = parentsSlice.actions;

export default parentsSlice;
